import React, { useEffect, useMemo, useState } from 'react';
import { Box, Breadcrumbs, Fab, IconButton, Link, Tooltip } from '@mui/material';
import { MdiIcon, Table } from '@components';
import { mdiMagnify, mdiPlus } from '@mdi/js';
import { useModal } from 'mui-modal-provider';
import { AddClienteDialog } from './dialog';
const CrmEmpresasListView = ({ $state, CrmService }) => {
    // ordenação das colunas
    // Ex: sortBy = ['morada:DESC']
    const loadParams = () => {
        const sortBy = $state.params.sortBy;
        if (sortBy == undefined) {
            return [];
        }
        const o = [];
        sortBy.forEach(r => {
            const s = r.split(':');
            o.push({ id: s[0], desc: s[1] == 'DESC' });
        });
        return o;
    };
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const [refetching, setRefetching] = useState(false);
    const [error, setError] = useState(false);
    const [filter, setFilter] = useState([]);
    const [sort, setSort] = useState(() => loadParams()); // só é chamado quando o componente é montado
    const [options, setOptions] = useState({
        filter: [],
        sort: []
    });
    const [pagination, setPagination] = useState({
        pageIndex: $state.params.page - 1 || 0,
        pageSize: $state.params.limit || 20
    });
    const initialTableState = useMemo(() => ({
        sort,
        filter
    }), [sort, filter]);
    const columns = useMemo(() => [
        /* {
        accessorKey: 'id',
        header: 'ID',
        size: 20
      }, */
        {
            accessorKey: 'nome',
            header: 'Nome',
            size: 200
        },
        /* {
        accessorKey: 'ultimoContacto',
        header: 'Último contacto',
        size: 120,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value != undefined) return moment(value).format('DD-MM-YYYY');
          return '-';
        }
      }, */
        {
            accessorKey: 'refClientePrimavera',
            header: 'Ref. Primavera',
            size: 100
        },
        {
            accessorKey: 'contactoTelefonico',
            header: 'Contacto Telefónico',
            size: 100
        },
        {
            accessorKey: 'nif',
            header: 'NIF',
            size: 100
        },
        {
            accessorKey: 'email',
            header: 'Email',
            size: 150
        },
        {
            accessorKey: 'morada',
            header: 'Morada',
            size: 150
        },
        {
            accessorKey: 'localidade',
            header: 'Localidade',
            size: 150
        }
    ], []);
    const { showModal } = useModal();
    // Filtragem dentro de cada coluna
    // Modo de filtro (igual a, contém, começa com... )
    const getType = (type) => {
        switch (type) {
            case 'contains':
                return '$ilike';
            case 'startsWith':
                return '$sw';
            case 'notEquals':
                return '$not';
            case 'empty':
                return '$null';
            case 'notEmpty':
                return '$notNull';
            case 'greaterThan':
                return '$gt';
            case 'greaterThanOrEqualTo':
                return '$gte';
            case 'lessThan':
                return '$lt';
            case 'lessThanOrEqualTo':
                return '$lte';
            default:
                return '$eq';
        }
    };
    // ir para detalhes da empresa (envia id da empresa)
    const onCellView = (cell) => {
        $state.go('app.crm.empresas.details', { id: cell.id });
    };
    const initialFetch = async () => {
        if (loading) {
            // opt -> vai buscar os campos filtraveis
            const opt = await CrmService.optionsClientes();
            setOptions(opt);
            setLoading(false);
        }
    };
    const fetchData = async () => {
        setError(false);
        try {
            let filters = {};
            filter.forEach(r => {
                filters[r.id] = `${getType(r.type)}:${r.value}`;
            });
            let sorter = [];
            sort.forEach(r => {
                sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
            });
            const aux = await CrmService.findAllClientes({
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                filter: filters,
                sortBy: sorter
            });
            $state.go($state.current.name, {
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                sortBy: sorter,
                filter: Object.keys(filter).length > 0 ? JSON.stringify(filters) : undefined
            }, {
                notify: false,
                reload: false,
                location: 'replace',
                inherit: true
            });
            // Update URL
            setData(aux);
        }
        catch (e) {
            console.log(e);
            setError(true);
        }
        setRefetching(false);
    };
    const handleDialogData = async (cli) => {
        try {
            await CrmService.addClienteAndContactos(cli, []);
            setRefetching(true);
            fetchData();
        }
        catch (error) {
            console.log('Erro ao adicionar cliente: ', error);
        }
    };
    useEffect(() => {
        initialFetch();
        if (!refetching) {
            setRefetching(true);
            fetchData();
        }
    }, [pagination, filter, sort]);
    return (<Box sx={{ mt: 2, pl: 1, pr: 1 }}>
      <Breadcrumbs aria-label='breadcrumb'>
        <Link underline='none' color='inherit'>
          CRM
        </Link>
        <Link underline='hover' color='text.primary' aria-current='page'>
          Clientes
        </Link>
      </Breadcrumbs>

      <Box sx={{
            mt: 2,
            borderRadius: '15px',
            border: '1px solid #e0e0e0',
            overflow: 'hidden',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
        }}>
        <Table onDoubleClick={row => {
            onCellView(row);
        }} storageKey={$state.current.name} data={data} columns={columns} initial={initialTableState} isLoading={refetching} options={options} onPaginate={setPagination} onFilter={setFilter} onSort={setSort} actionItems={({ row }) => [
            <Box key={`actions-${row.original.id}`} gap={1} sx={{
                    width: '100%', // Ocupa toda a largura da célula
                    height: '100%', // Ocupa toda a altura da célula
                    display: 'flex',
                    justifyContent: 'center', // Centra horizontalmente
                    alignItems: 'center' // Centra verticalmente
                }}>
              <Tooltip title={'Ver detalhes'} placement='top'>
                <IconButton color='secondary' onClick={() => {
                    $state.go('app.crm.empresas.details', { id: row.original.id });
                }}>
                  <MdiIcon path={mdiMagnify} sx={{ color: '#1976D2' }}/>
                </IconButton>
              </Tooltip>
            </Box>
        ]}></Table>
      </Box>
      <Fab aria-label='add' color='error' sx={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            zIndex: 1000
        }} onClick={() => showModal(AddClienteDialog, {
            CrmService: CrmService,
            title: 'Adicionar Cliente',
            onClose: _ => {
                if (_) {
                    handleDialogData(_);
                }
            }
        })}>
        <MdiIcon path={mdiPlus} sx={{ color: '#ffffff' }}/>
      </Fab>
    </Box>);
};
export default CrmEmpresasListView;
